export const ADMIN_REGISTER_USER_REQUEST = 'ADMIN_REGISTER_USER_REQUEST'
export const ADMIN_REGISTER_USER_SUCCESS = 'ADMIN_REGISTER_USER_SUCCESS'
export const ADMIN_REGISTER_USER_FAIL = 'ADMIN_REGISTER_USER_FAIL'
export const ADMIN_REGISTER_USER_RESET = 'ADMIN_REGISTER_USER_RESET'

export const ADMIN_UPDATE_USER_REQUEST = 'ADMIN_UPDATE_USER_REQUEST'
export const ADMIN_UPDATE_USER_SUCCESS = 'ADMIN_UPDATE_USER_SUCCESS'
export const ADMIN_UPDATE_USER_FAIL = 'ADMIN_UPDATE_USER_FAIL'
export const ADMIN_UPDATE_USER_RESET = 'ADMIN_UPDATE_USER_RESET'

export const ADMIN_GET_USER_REQUEST = 'ADMIN_GET_USER_REQUEST'
export const ADMIN_GET_USER_SUCCESS = 'ADMIN_GET_USER_SUCCESS'
export const ADMIN_GET_USER_FAIL = 'ADMIN_GET_USER_FAIL'
export const ADMIN_GET_USER_RESET = 'ADMIN_GET_USER_RESET'
